import React from 'react'
import Terrain from '@material-ui/icons/Terrain'

export default function TerrainIcon(props) {
    const { ...other } = props

    return (
        <Terrain {...other} />
    )
}